import React from "react";
import { useEvent } from "./useEvent";
import { unstable_batchedUpdates as batch } from "react-dom";

export const useAutocompleteFocusCapture = () => {
  const [focused, forceFocus] = React.useState(false);

  const onFocusCapture = useEvent((ev: React.FocusEvent<HTMLElement>, callback?: React.FocusEventHandler<HTMLElement>) => {
    if (focused) {
      return;
    }

    batch(() => {
      forceFocus(true);
      callback?.(ev);
    });
  });

  const onBlurCapture = useEvent((ev: React.FocusEvent<HTMLElement>, callback?: React.FocusEventHandler<HTMLElement>) => {
    const currentTarget = ev.currentTarget;

    /**
     * Wait for a single tick to ensure that the activeElement does not return
     * to the target. This can happen with ariakit where it BRIEFLY makes the
     * body the document.activeElement on popovers.
     */
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        batch(() => {
          forceFocus(false);
          callback?.(ev);
        });
      }
    });
  });

  return { focused, onFocusCapture, onBlurCapture, forceFocus };
};
